<template>
  <div class="modal-wrapper">
    <div class="modal">
      <div class="modal-header">
        <div class="new-input">
          <span class="tms">N</span>
          <input type="text" :placeholder="$t('search')" v-model="searchMaterials" />
        </div>
        <span class="tms modal-close" @click="close()">F</span>
      </div>
      <div class="modal-content" v-if="!isCommingFromReport">
        <!-- IMPORT TEMPLATE -->
        <div v-if="!materials.length" class="modal-content-template" @click="triggerFileInput()">
          <img
            class="modal-content-template-img desktop"
            :src="getImg(false)"
            :alt="$t('table-structure')"
          />
          <img
            class="modal-content-template-img mobile"
            :src="getImg(true)"
            :alt="$t('table-structure')"
          />
        </div>
        <div
          class="modal-content-item with-edit"
          v-for="(material, index) in filteredMaterials"
          :key="`materialModal-${index}-${material.name}`"
          :class="{ 'modal-content-check-additional': material.isAdditional }"
          :title="material.name"
        >
          <span v-if="material.isAdditional">⚡</span>
          <p>{{material.name}}</p>
          <span class="tms edit" @click="editMaterial(index)" title>c</span>
          <span class="tms" @click="deleteMaterial(index)" title>b</span>
        </div>
        <!-- NO RESULTS -->
        <p class="modal-content-no-results" v-if="materials.length && !filteredMaterials.length">
          {{ $t('no-results-for') }} '
          <strong>{{this.searchMaterials}}</strong>'
        </p>
      </div>
      <div class="modal-content" v-else>
        <p
          v-if="!materials.length"
          class="modal-content-no-results text-align-center"
        >{{ $t('no-materials') }}</p>
        <div
          class="modal-content-item"
          v-for="(material, index) in filteredMaterials"
          :key="`addMaterialsModal-${index}-${material._id}`"
          @click="saveSingle(material)"
          :class="{ 'modal-content-check-additional': material.isAdditional }"
          :title="material.name"
        >
        <span v-if="material.isAdditional">⚡</span>
        {{ material.name }}</div>
        <!-- NO RESULTS -->
        <p class="modal-content-no-results" v-if="materials.length && !filteredMaterials.length">
          {{ $t('no-results-for') }} '
          <strong>{{this.searchMaterials}}</strong>'
        </p>
      </div>
      <div class="modal-footer">
        <div class="add-row" v-if="isCommingFromReport" @click="isEditItemModalOpened = true">
          <span class="icon">+</span>
          <p>{{ $t('new-material') }}</p>
        </div>
        <div v-else>
          <!-- EMPTY DIV FOR THE SPACE-AROUND RULE TO WORK -->
        </div>
        <div class="btns" v-if="!isCommingFromReport">
          <button class="btn btn-excel" @click="triggerFileInput()">
            <span class="tms">E</span>
            {{ $t('new-file') }}
          </button>
          <input ref="uploadMaterials" class="input-hide" type="file" value="C:\fakepath" @change="handleFile" />
          <button class="btn btn-new" @click="save()">
            <span class="tms">Y</span>
            {{ $t('save') }}
          </button>
        </div>
      </div>
    </div>
    <EditInputModal v-if="isEditInputModalOpened" :isComingFromMaterials="true"></EditInputModal>
    <EditItemModal
      v-if="isEditItemModalOpened"
      :isComingFromMaterials="true"
      type="material"
      :obj="materials[selectedIndex]"
      @create="handleAdd"
      @edit="handleEditMaterial"
      @close="closeEditItemModalModal"
    />
  </div>
</template>

<script>
import XLSX from 'xlsx';
import EditInputModal from './EditInputModal';
import EditItemModal from './EditItemModal';
export default {
  components: {
    EditInputModal,
    EditItemModal
  },
  props: [
    'incomingMaterials',
    'isCommingFromReport',
    'companyId',
    'objectId',
    'partId'
  ],
  watch: {
    incomingMaterials() {
      this.initMaterials();
    }
  },
  data() {
    return {
      isEditInputModalOpened: false,
      isEditItemModalOpened: false,
      materials: [],
      selectedIndex: undefined,
      searchMaterials: ''
    };
  },
  computed: {
    filteredMaterials() {
      return this.filterMaterials();
    }
  },
  methods: {
    getImg(mobile) {
      return `${process.env.VUE_APP_STATIC_URI}/table_help${
        mobile ? '_mobile' : ''
      }_${this.$i18n.locale}.png`;
    },
    triggerFileInput() {
      this.$refs.uploadMaterials.click();
    },
    // EXCEL FILE TO JSON
    handleFile(e) {
      let rABS = true; // true: readAsBinaryString ; false: readAsArrayBuffer
      const files = e.target.files;
      const f = files[0];
      if (f.name.match(`.(xls|XLS|xlsx|XLSX)$`)) {
        const reader = new FileReader();
        reader.onload = e => {
          let data = e.target.result;
          if (!rABS) data = new Uint8Array(data);
          const workbook = XLSX.read(data, { type: rABS ? 'binary' : 'array' });

          /* DO SOMETHING WITH workbook HERE */
          const rows = this.workbookToJSON(workbook);
          // SHEET
          for (let row in rows) {
            const keys = Object.keys(rows[row][0]);
            const values = Object.values(rows[row]);

            for (let v of values) {
              let cols = Object.keys(v);

              for (let c of cols) {
                if (c.toLocaleLowerCase() === 'цена'  && typeof v[c] !== 'number')
                return this.$snotify.error(`Невалидна стойност в клетка Цена`);
              }

              if (cols.length !== 3) {
                return this.$snotify.error('Таблицата има празни клетки и не може да бъде импортирана. Попълнете ги и пробвайте отново');
              }
            }
            for (let i = 0; i < keys.length; i++) {
              if (
                !(
                  keys[i].toLowerCase().includes(this.$t('table-name')) ||
                  keys[i].toLowerCase().includes(this.$t('table-unit')) ||
                  keys[i].toLowerCase().includes(this.$t('table-price'))
                )
              ) {
                this.$snotify.error(this.$t('table-warning'));
                return;
              }
            }
            // ROW OBJECT
            for (let item in rows[row]) {
              // ROW DATA
              this.materials.push({
                name: rows[row][item][Object.keys(rows[row][item])[0]].toString(),
                unit: rows[row][item][Object.keys(rows[row][item])[1]],
                price: rows[row][item][Object.keys(rows[row][item])[2]]
              });
            }
          }
        };
        if (rABS) reader.readAsBinaryString(f);
        else reader.readAsArrayBuffer(f);
      } else {
        this.$snotify.error(this.$t('table-warning-xls'));
      }

      // input @change was not reacting to new files
      e.target.value = null
    },
    workbookToJSON(workbook) {
      var result = {};
      workbook.SheetNames.forEach(sheetName => {
        var roa = XLSX.utils.sheet_to_row_object_array(
          workbook.Sheets[sheetName]
        );
        if (roa.length > 0) {
          result[sheetName] = roa;
        }
      });
      return result;
    },
    filterMaterials() {
      return this.materials.filter(m => {
        return m.name
          .toLowerCase()
          .includes(this.searchMaterials.toLowerCase());
      });
    },
    // Handle added material from EditInput
    handleAdd(newMaterial) {
      if (this.partId) {
        let url = `${process.env.VUE_APP_BASE_URI}/company/${this.companyId}`;
        this.$http
          .get(url)
          .then((response) => {
            const company = response.data;
            // get index of selected project
            const indexOfObject = company.objects.findIndex(
              (p) => p._id === this.objectId
            );
            // get index of selected object
            const indexOfPart = company.objects[indexOfObject].parts.findIndex(
              (o) => o._id === this.partId
            );

            company.objects[indexOfObject].parts[indexOfPart].materials.push(
              newMaterial
            );

            // make the post request
            let url = `${process.env.VUE_APP_BASE_URI}/company/${company._id}`;

            this.$http
              .put(url, company)
              .then(() => {
                this.$snotify.success(this.$t("success-material"));
                this.$emit("getMaterialsAgain");
              })
              .catch((error) => {
                console.log(error);
                this.$snotify.error(this.$t("something-went-wrong"));
              });
          })
          .catch((error) => console.log(error));
      } else {
        this.saveSingle(newMaterial);
      }
    },
      editMaterial(i) {
      this.selectedIndex = i;
      this.isEditItemModalOpened = true;
    },
    handleEditMaterial(a) {
      this.materials[this.selectedIndex].name = a.name;
      this.materials[this.selectedIndex].unit = a.unit;
      this.materials[this.selectedIndex].price = a.price;
      this.materials[this.selectedIndex].updateInReports = true;

      this.$set(
        this.materials,
        this.selectedIndex,
        this.materials[this.selectedIndex]
      );
    },
        closeEditItemModalModal() {
      this.isEditItemModalOpened = false;
      this.selectedIndex = null;
    },
    deleteMaterial(i) {
      this.materials.splice(i, 1);
    },
    close() {
      this.$parent.$emit('closeAddMaterialsModal');
    },
    saveSingle(m) {
      this.$parent.$emit('saveAddMaterialsModal', [{
        _id: m._id,
        name: m.name.toString(),
        unit: m.unit,
        price: m.price,
        isAdditional: m.isAdditional,
      }]);
    },
    save() {
      this.$parent.$emit('saveAddMaterialsModal', this.materials);
    },
    initMaterials() {
      this.materials = this.$cloneDeep(this.incomingMaterials);

      this.materials.sort((x, y) => {
        return x.isSelected === y.isSelected ? 0 : x.isSelected ? -1 : 1;
      });
    },
    closeEditInputModal() {
      this.isEditInputModalOpened = false;
    },
    closeEditItemModal() {
      this.isEditItemModalOpened = false;
    }
  },
  mounted() {
    this.initMaterials();
    this.$on('saveMaterialActivityOrMechanization', this.handleAdd);
    this.$on('closeEditInputModal', this.closeEditInputModal);
    this.$on('closeEditItemModal', this.closeEditItemModal);
    this.$eventBus.$on('closeModalFromSpeechRecognition', () => {
      this.close();
    });
  },
  destroyed() {
    this.$off('saveMaterialActivityOrMechanization');
    this.$eventBus.$off('closeModalFromSpeechRecognition');
  }
};
</script>

<style scoped>
.model-wrapper {
  justify-content: center;
}
/* .modal-header {
  background: #17643a;
} */
.desktop {
  display: initial;
}
.mobile {
  display: none;
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .modal {
    max-height: 90vh;
    overflow: unset;
    width: 90%;
  }
  .modal-content-item {
    height: fit-content;
    min-height: 55px;
    width: 100%;
  }
  .modal-content-check {
    margin-bottom: 5px;
    width: 100%;
  }
}
@media screen and (max-width: 700px) {
  .modal-footer {
    height: 98px;
    flex-direction: column;
  }
  .btn.btn-new {
    margin-bottom: 0.8em;
  }
  .btns-select {
    display: flex;
    justify-content: center;
    margin-top: 1em;
  }
  .btn-select {
    padding: 0 10px;
  }
}
@media screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: initial;
  }
  .modal-header .new-input {
    width: 60%;
  }
}
@media screen and (max-width: 500px) {
  .btns {
    display: flex;
    flex-direction: column;
  }
  .btn.btn-excel {
    margin-bottom: 0.5em;
  }
}
</style>
